import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { SizePane } from 'page/ProfileScreen/SizeSlider/SizePane'
import { isMax } from 'page/ProfileScreen/SizeSlider/SizeSlider'
import { store } from 'store/store'

export const HeightSlider = observer(() => {
  const form = store.profile.form
  const { min, max } = store.profile.form.cfg.dimensions.height
  const value = form.height
  const plus = isMax(value, max)

  const onChange = useLatestCallback((value: number) => {
    form.setHeight(value)
  })

  return <SizePane label={i18n('Height')} value={value} plus={plus}
    min={min} max={max} onChange={onChange} />
})
